import {FullscreenOverlayWithSpinner} from '@yandex-delivery/blocks'
import type {FC} from 'react'

import {ActionProvider, StatusProvider} from '../../contexts'
import {renderWidget} from '../../widgets'
import {LayoutSkeleton} from '../LayoutSkeleton/index@mobile'
import * as classes from './Form@mobile.classes'
import {useOrderForm} from './hooks/use-order-form'

export const Form: FC = () => {
  const {layout, isFetching, isLoading, onSubmit, isOverlayVisible} = useOrderForm()

  if (!isLoading && !layout) {
    throw new Error('Root form widget is not found')
  }

  return (
    <StatusProvider isFetching={isFetching}>
      <ActionProvider onSubmit={onSubmit}>
        {isOverlayVisible && <FullscreenOverlayWithSpinner />}
        <main className={classes.main}>{layout ? renderWidget(layout, 'layout') : <LayoutSkeleton />}</main>
      </ActionProvider>
    </StatusProvider>
  )
}
